module.exports = __webpack_public_path__ + "img/logo-black.b2063116.svg";